export const doughnutLegends = [
  { title: 'Phân xưởng 1', color: 'bg-blue-500' },
  { title: 'Phân xưởng 2', color: 'bg-teal-600' },
  { title: 'Phân xưởng 3', color: 'bg-purple-600' },
];

export const lineLegends = [
  { title: 'Organic', color: 'bg-teal-600' },
  { title: 'Paid', color: 'bg-purple-600' },
];

export const barLegends = [
  { title: 'Đã sử dụng', color: 'bg-blue-700' },
  { title: 'Dự kiến', color: 'bg-blue-600' },
];

export const doughnutOptions = {
  data: {
    datasets: [
      {
        data: [25, 35, 40],
        backgroundColor: ['#0694a2', '#1c64f2', '#7e3af2'],
        label: 'PHÂN BỔ LƯỢNG ĐIỆN TIÊU THỤ NHÀ MÁY 2',
      },
    ],
    labels: ['Phân xưởng 1', 'Phân xưởng 2', 'Phân xưởng 3'],
  },
  options: {
    responsive: true,
  },
  legend: {
    display: true,
  },
};

export const lineOptions = {
  data: {
    labels: [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
    ],
    datasets: [
      {
        type: 'line',
        label: 'Công suất',
        borderColor: '#108775',
        borderWidth: 1,
        backgroundColor: 'transparent',
        pointBorderColor: 'transparent',
        fill: false,
        data: [
          5,
          7,
          9,
          8,
          7.5,
          4.5,
          5,
          7,
          6,
          8,
          6.5,
          4.8,
          7,
          8,
          8,
          7,
          5.5,
          7,
          6,
          6.5,
          8,
          4,
          8,
          7,
          8,
          5,
          8,
          6,
          8,
          5,
          7,
          9,
          6,
          7,
          7.5,
          6,
          8,
          7.5,
          7,
          5,
          7,
          6,
          9,
          5,
          7,
          6,
          8,
          8,
          7.8,
          8,
          7,
          5,
          7,
          8,
          4,
          8,
          6,
        ],
        yAxisID: 'y-axis-1',
      },
    ],
  },
  options: {
    responsive: true,
    scales: {
      yAxes: [
        {
          type: 'linear',
          display: true,
          position: 'left',
          id: 'y-axis-1',
          scaleLabel: {
            display: false,
            labelString: 'kWh',
          },
          ticks: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            display: false,
          },
        },
      ],
    },
  },
  legend: {
    display: true,
    labels: {
      fontColor: 'rgba( 113, 113, 113, 0.95)',
    },
  },
};

export const barOptions = {
  data: {
    labels: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
    ],
    datasets: [
      {
        type: 'line',
        label: 'Công suất',
        borderColor: '#2F495E',
        borderWidth: 1,
        backgroundColor: 'transparent',
        pointBorderColor: 'transparent',
        fill: false,
        data: [
          2,
          3,
          5,
          8,
          11,
          14,
          16,
          22,
          23,
          25,
          28,
          30,
          31,
          32,
          34,
          37,
          39,
          40,
          43,
          44,
          45,
          47,
          50,
          51,
          52,
          54,
          55,
          58,
          59,
          60,
          64,
        ],
        yAxisID: 'y-axis-1',
      },
      {
        label: 'Đã sử dụng',
        data: [
          2,
          3,
          5,
          8,
          11,
          14,
          16,
          22,
          23,
          25,
          28,
          30,
          31,
          32,
          34,
          37,
          39,
          40,
          43,
          44,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
        ],
        stack: 1,
        backgroundColor: '#00C58E',
      },
      {
        label: 'Dự kiến',
        data: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          45,
          47,
          50,
          51,
          52,
          54,
          55,
          58,
          59,
          60,
          64,
        ],
        stack: 1,
        backgroundColor: '#BBF7D0',
      },
    ],
  },
  options: {
    responsive: true,
    scales: {
      yAxes: [
        {
          type: 'linear',
          display: true,
          position: 'left',
          id: 'y-axis-1',
          scaleLabel: {
            display: true,
            labelString: 'kWh',
          },
        },
      ],
    },
  },
  legend: {
    display: false,
  },
};

export const lineWattageOptions = {
  data: {
    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    datasets: [
      {
        type: 'line',
        label: 'Công suất',
        borderColor: '#108775',
        borderWidth: 1,
        backgroundColor: '#B3D9D3',
        pointBorderColor: '#108775',
        fill: true,
        data: [5, 7, 9, 8, 7.5, 4.5, 5, 7, 6, 8, 6.5, 4.8],
        yAxisID: 'y-axis-1',
      },
    ],
  },
  options: {
    responsive: true,
    scales: {
      yAxes: [
        {
          type: 'linear',
          display: true,
          position: 'left',
          id: 'y-axis-1',
          scaleLabel: {
            display: true,
            labelString: 'kWh',
          },
          ticks: {
            display: true,
          },
        },
      ],
      xAxes: [
        {
          display: false,
        },
      ],
    },
  },
  legend: {
    display: false,
  },
};

export const barWattagOptions = {
  data: {
    labels: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
    ],
    datasets: [
      {
        label: 'Device 1',
        data: [
          25,
          31,
          32,
          28,
          25,
          27,
          16,
          22,
          23,
          21,
          28,
          19,
          22,
          24,
          21,
          27,
          29,
          32,
          31,
          18,
          17,
          21,
          26,
          24,
          23,
          27,
          25,
          29,
          23,
          25,
          32,
        ],
        stack: 1,
        backgroundColor: '#00C58E',
      },
      {
        label: 'Device 2',
        data: [
          10,
          12,
          11,
          14,
          15,
          12,
          14,
          10,
          16,
          10,
          14,
          14,
          15,
          18,
          13,
          14,
          18,
          19,
          13,
          15,
          15,
          17,
          10,
          11,
          12,
          17,
          13,
          19,
          12,
          11,
          15,
        ],
        stack: 1,
        backgroundColor: '#2F495E',
      },
      {
        label: 'Device 3',
        data: [
          5,
          12,
          7,
          14,
          13,
          12,
          8,
          10,
          3,
          10,
          14,
          14,
          6,
          9,
          13,
          14,
          18,
          9,
          13,
          12,
          15,
          7,
          10,
          11,
          12,
          7,
          13,
          4,
          12,
          11,
          15,
        ],
        stack: 1,
        backgroundColor: '#B3D9D3',
      },
    ],
  },
  options: {
    responsive: true,
    scales: {
      yAxes: [
        {
          type: 'linear',
          display: true,
          position: 'left',
          id: 'y-axis-1',
          scaleLabel: {
            display: true,
            labelString: 'kWh',
          },
        },
        {
          type: 'linear',
          display: true,
          position: 'right',
          id: 'y-axis-1',
          scaleLabel: {
            display: true,
            labelString: 'kWh',
          },
        },
      ],
      xAxes: [
        {
          display: false,
        },
      ],
    },
  },
  legend: {
    display: false,
  },
};
